const React = require('react');
const formatTime = require('mn-utils/formatTime');
const getCountryByCode = require('../../../../utils/getCountryByCode');
const FieldA = require('../../../dumb/Field/A');

const Document = require('./Document');


module.exports = (props) => {
  const data = props.data || {};
  const {
    birthday,
  } = data;

  return (
    <div className="mh-15 cfx (w1/2|ph15|lt)>1">
      <div>
        <FieldA label="Full name *">
          {data.full_name || '-'}
        </FieldA>
        <FieldA label="Birthday">
          {birthday ? formatTime(new Date(birthday), '{yyyy}-{mm}-{dd}') : '-'}
        </FieldA>
        <FieldA label="Country of residence *">
          {getCountryByCode(data.country_of_residence)}
        </FieldA>
        <FieldA label="Country of birth *">
          {getCountryByCode(data.country_of_birth)}
        </FieldA>
      </div>
      <div>
        <FieldA label="Document type">
          {data.document_type || '-'}
        </FieldA>
        <FieldA label="Country of residence *">
          <Document data={data.document_identity}/>
        </FieldA>
        <FieldA label="Country of birth *">
          <Document data={data.document_address}/>
        </FieldA>
      </div>
    </div>
  );
};
